import * as React from 'react';
// import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { useApproveAssessment, useFetchManageReport, useFetchCriticalIssues, useUpdateCriticalIssue, useDownloadManageReport } from '../../hooks/api/dashboard/dashboard';
import { useQueries } from '@tanstack/react-query';
import { useFetchProjects } from '../../hooks/api/projects/projects';
import { toast } from 'react-toastify';
import { Pagination } from '@mui/material';

function createData(name, calories, fat, carbs, protein, price) {
  return {
    name,
    calories,
    fat,
    carbs,
    protein,
    price,
    history: [
      {
        date: '2020-01-05',
        customerId: '11091700',
        amount: 3,
      },
      {
        date: '2020-01-02',
        customerId: 'Anonymous',
        amount: 1,
      },
    ],
  };
}

function Row(props) {
  const { row , refetch} = props;
  const [open, setOpen] = React.useState(false);

  const approveAssessment= useApproveAssessment()

  const handleApproveAssessment=(assessmentId)=>{
  toast.dismiss()
toast.loading()
    approveAssessment.mutate(assessmentId, {
      onSuccess(data){
toast.dismiss()
toast.success(`Assessment Approved`)
refetch()

      },
      onError(err){
     toast.dismiss()
toast.error(`Undable to approve assessment`)
        
      }
    })
  }
  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row?.user?.firstName}
        </TableCell>
        <TableCell component="th" scope="row">
          {row?.SurveyType?.name}
        </TableCell>
        <TableCell align="right">{row?.status}</TableCell>
        <TableCell align="right" contentEditable>{row?.date}</TableCell>
        <TableCell align="right">{row?.total_score}</TableCell>
        <TableCell align="right">{row?.total_score_percentage}</TableCell>
        <TableCell align="right">
          <div className="">
          {row.status !=="approved"&&  <button onClick={()=>handleApproveAssessment(row?.id)}>Approve</button>
          }</div>
        </TableCell>
        {/* <TableCell align="right">{row.carbs}</TableCell> */}
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              {/* <Typography variant="h6" gutterBottom component="div">
                History
              </Typography> */}
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell size='medium' sx={{fontWeight:600}}>Category</TableCell>
                    <TableCell size='medium' sx={{fontWeight:600}}>Score</TableCell>
                    {/* <TableCell align="right">Total Score</TableCell>
                    <TableCell align="right">Total Score Percentage</TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row?.assessments_score_categories?.map((historyRow, i) => (
                    <TableRow key={i}>
                      <TableCell component="th" scope="row">
                        {historyRow?.category}
                      </TableCell>
                      <TableCell contentEditable  onChange={(e)=>{
                        console.log("test",e.target.value)
                      }}>
                        <input value={historyRow?.score}  />
                        </TableCell>
                      <TableCell align="right">{historyRow.total_score}</TableCell>
                      <TableCell align="right">
                        {historyRow?.total_score_percentage}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              {/* <Typography variant="h6" gutterBottom component="div">
                History
              </Typography> */}
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell size='medium' sx={{fontWeight:600}}>SN</TableCell>
                    <TableCell size='medium' sx={{fontWeight:600}}>Flagged Response</TableCell>
                    {/* <TableCell align="right">Total Score</TableCell>
                    <TableCell align="right">Total Score Percentage</TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row?.flag_reason?.map((historyRow, index) => (
                    <TableRow key={index}>
                      <TableCell component="th" scope="row">
                        {index+1}
                      </TableCell>
                      {/* <TableCell >
                        <input value={historyRow?.score}  />
                        </TableCell> */}
                      <TableCell align="left">{historyRow}</TableCell>
                      {/* <TableCell align="right">
                        {historyRow?.total_score_percentage}
                      </TableCell> */}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              {/* <Typography variant="h6" gutterBottom component="div">
                History
              </Typography> */}
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell size='medium' sx={{fontWeight:600}}>SN</TableCell>
                    <TableCell size='medium' sx={{fontWeight:600}}>Question</TableCell>
                    <TableCell size='medium' sx={{fontWeight:600}}>Category</TableCell>
                    <TableCell size='medium' sx={{fontWeight:600}}>Flagged Response</TableCell>
                    {/* <TableCell align="right">Total Score</TableCell>
                    <TableCell align="right">Total Score Percentage</TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row?.openEndedResponses?.map((response, index) => (
                    <TableRow key={index}>
                      <TableCell component="th" scope="row">
                        {index+1}
                      </TableCell>
                      {/* <TableCell >
                        <input value={historyRow?.score}  />
                        </TableCell> */}
                      <TableCell align="left">{response?.survey?.question}</TableCell>
                      <TableCell align="left">{response?.survey?.category}</TableCell>
                      <TableCell align="left">{response?.response}</TableCell>
                      {/* <TableCell align="right">
                        {historyRow?.total_score_percentage}
                      </TableCell> */}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

// Row.propTypes = {
//   row: PropTypes.shape({
//     calories: PropTypes.number.isRequired,
//     carbs: PropTypes.number.isRequired,
//     fat: PropTypes.number.isRequired,
//     history: PropTypes.arrayOf(
//       PropTypes.shape({
//         amount: PropTypes.number.isRequired,
//         customerId: PropTypes.string.isRequired,
//         date: PropTypes.string.isRequired,
//       }),
//     ).isRequired,
//     name: PropTypes.string.isRequired,
//     price: PropTypes.number.isRequired,
//     protein: PropTypes.number.isRequired,
//   }).isRequired,
// };

const rows = [
  createData('Frozen yoghurt', 159, 6.0, 24, 4.0, 3.99),
  createData('Ice cream sandwich', 237, 9.0, 37, 4.3, 4.99),
  createData('Eclair', 262, 16.0, 24, 6.0, 3.79),
  createData('Cupcake', 305, 3.7, 67, 4.3, 2.5),
  createData('Gingerbread', 356, 16.0, 49, 3.9, 1.5),
];

export default function ManageReport() {
  const [filters, setFilters]= React.useState({
    orgId:"",
    projectId:"",
    download:false,
    pageNumber:1
  })
  const [manageReportActiveNumber, setManageReportActiveNumber]= React.useState(1)

  const fetchProjects= useFetchProjects(filters)
  const fetchCriticalIssues= useFetchCriticalIssues()
  const updateCriticalIssue=useUpdateCriticalIssue()
 const downloadReport= useDownloadManageReport()
  console.log({fetchProjects, fetchCriticalIssues})
const fetchManageReport= useFetchManageReport({...filters, pageNumber:manageReportActiveNumber})

const handleApproveCriticalIssues=(id)=>{
  toast.dismiss()
  toast.loading(`Processing.. Please wait`)
updateCriticalIssue.mutate({id}, {
  onSuccess(){
    toast.dismiss()
    toast.success(`Critical Issues updated `)
    fetchCriticalIssues.refetch()
  },
  onError(){
    toast.dismiss()
    toast.error(`Unable to update critical issue`)
  }
})
}

const handlePageChange = (event, value) => {
  setFilters(prev=>({...prev, pageNumber:value}))
};

  return (<>
  
  <div className="flex justify-between items-center px-6 mb-4">
    <div className="">
<label htmlFor="project" className='block'>Select Project </label>
    <select name="select-project" id="project"
    className='border rounded-md w-96 p-4'
    onChange={e=>setFilters(prev=>({...prev, projectId:e.target.value}))}>
      <option value="">Select</option>
      {fetchProjects.data?.projects?.map((project, index)=><option key={index} value={project?.id}>{project?.name}</option>)}
    </select>
    </div>


    <div className="">
      <button 
      className='p-4 px-6 bg-green-300 rounded-md '
      onClick={e=>downloadReport.mutate(filters)}
      >Download</button>
    </div>
  </div>
    <TableContainer component={Paper}>
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow size='medium' sx={{fontWeight:600}}>
            <TableCell />
            <TableCell size='medium' sx={{fontWeight:600}}>Shopper Name</TableCell>
            <TableCell size='medium' sx={{fontWeight:600}}>Survey Name</TableCell>
            <TableCell size='medium' sx={{fontWeight:600}} align="right">Status</TableCell>
            <TableCell size='medium' sx={{fontWeight:600}} align="right">Date </TableCell>
            <TableCell size='medium' sx={{fontWeight:600}} align="right">Total Score </TableCell>
            <TableCell size='medium' sx={{fontWeight:600}} align="right">Total Score Percentage</TableCell>
            <TableCell size='medium' sx={{fontWeight:600}} align="right">Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {
            fetchManageReport.isLoading ?
            <div class="spinner"></div>

            :
          fetchManageReport.data?.assessments?.map((row, i) => (
            <Row key={row?.SurveyType?.name+i} row={row} refetch={fetchManageReport.refetch} />
          ))}
        </TableBody>
      </Table>
      <Pagination
     count={fetchManageReport.data?.pagination?.totalPages} 
     page={manageReportActiveNumber} 
     onChange={(e, newValue)=>setManageReportActiveNumber(newValue)} />
    </TableContainer>



    <div className="mt-6">

<h2 classNmae="mb-4 text-3xl font-semibold"> Critical Issues</h2>
    <TableContainer component={Paper}>
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow size='medium' sx={{fontWeight:600}}>
            <TableCell />
            <TableCell size='medium' sx={{fontWeight:600}}>Shopper Name</TableCell>
            <TableCell size='medium' sx={{fontWeight:600}}>Survey Name</TableCell>
            <TableCell size='medium' sx={{fontWeight:600}} align="">Category </TableCell>
            <TableCell size='medium' sx={{fontWeight:600}} align="">Message </TableCell>
            {/* <TableCell size='medium' sx={{fontWeight:600}} align="right"></TableCell> */}
            {/* <TableCell size='medium' sx={{fontWeight:600}} align="right">Status</TableCell> */}
            <TableCell size='medium' sx={{fontWeight:600}} align="right">Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>

          
          {
          fetchCriticalIssues?.isLoading ? <div className="spinner"></div>
          :fetchCriticalIssues?.data?.data?.map((row, index) => (
            <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
            <TableCell>
              {/* <IconButton
                aria-label="expand row"
                size="small"
                onClick={() => setOpen(!open)}
              >
                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </IconButton> */}
            </TableCell>
            <TableCell component="th" scope="row">
              {row?.user?.firstName}
            </TableCell>
            <TableCell align="">{row?.project?.name}</TableCell>
      
            <TableCell component="th" scope="row">
              {row?.category}
            </TableCell>
            <TableCell component="th" scope="row">
              {row?.message}
            </TableCell>
             {/* <TableCell align="right" contentEditable>{row?.date}</TableCell>
            <TableCell align="right">{row?.total_score}</TableCell>
            <TableCell align="right">{row?.total_score_percentage}</TableCell> */}
            <TableCell align="right">
              <div className="">
              {row.status !=="approved"&&  <button onClick={()=>handleApproveCriticalIssues(row?.id)}>Approve</button>
              }</div>
            </TableCell>
            {/* <TableCell align="right">{row.carbs}</TableCell> */}
          </TableRow>
           
           ))}
        </TableBody>
      </Table>
    </TableContainer>

            

      </div>
    </>
  );
}
